import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Link, useLocation, useParams } from "react-router-dom";
import { getQuotationByID } from "./services/quotation.services";
import { LoadingPanel } from "../../components/layout/Loading";
import moment from "moment";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import { PDF_DOWNLOAD_ACCESS, PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";
import { API_URL } from "../../app/config";
import { ErrorToast } from "../../components/toast/Toasts";
import defaultitineraryimage from "../../assets/Images/default-itinerary-image.jpg";
import NoDataFoundPage from "../../components/common/NoDataFoundPage";
import { getLocalWebsiteHeader } from "../../app/getTokens";

const PackageQuotationPrint = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const location = useLocation();
  const Quot_GUID = params?.Quot_GUID;

  const withoutBifurcation = location.search?.split("?")?.[1] === "wb";

  const QuotationDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail,
  );
  const isPrintAccess = checkAcessRights("/quotation", PRINT_ACCESS);
  const isPDFDownloadAccess = checkAcessRights(
    "/quotation",
    PDF_DOWNLOAD_ACCESS,
  );
  const [downloadLoading, setDownloadLoading] = useState(false);

  const CompanyDetail = QuotationDetail?.CompanyDetails;

  const TotalAccommodationRate = QuotationDetail?.TotalAccommodationRate || 0;
  const TotalTransportation = QuotationDetail?.TotalTransportation || 0;
  const TotalMiscellaneous = QuotationDetail?.TotalMiscellaneous || 0;
  const TotalSightSeen = QuotationDetail?.TotalSightSeen || 0;

  const convertedTotalAccommodationRate =
    (+(QuotationDetail?.AccommodationMarkup || 0) + +TotalAccommodationRate) *
      (QuotationDetail?.AccommodationConversionRate || 0) || 0;
  const convertedTotalTransportation =
    (+(QuotationDetail?.TransportMarkup || 0) + +TotalTransportation) *
      (QuotationDetail?.TransportaionConversionRate || 0) || 0;
  const convertedTotalMiscellaneous =
    (+(QuotationDetail?.MiscellaneousMarkup || 0) + +TotalMiscellaneous) *
      (QuotationDetail?.MiscellaneousConversionRate || 0) || 0;
  const convertedTotalSightSeen =
    (+(QuotationDetail?.SightSeenMarkup || 0) + +TotalSightSeen) *
      (QuotationDetail?.SightSeenConversionRate || 0) || 0;

  const loading = useAppSelector((state) => state.quotation.loading);

  useEffect(() => {
    if (Quot_GUID) {
      dispatch(getQuotationByID({ Quot_GUID: Quot_GUID }));
    }
  }, [Quot_GUID]);

  const calculateSubtotal = (): number => {
    return (
      convertedTotalAccommodationRate +
      convertedTotalTransportation +
      convertedTotalMiscellaneous +
      convertedTotalSightSeen
    );
  };

  const calculateAfterDiscount = (): number => {
    return calculateSubtotal() - (QuotationDetail.DiscountAmt || 0);
  };

  const handleDownloadInvoice = async (ID: any) => {
    const website = getLocalWebsiteHeader();
    const payload = {
      ID: ID ? +ID : null,
      Is_Bifurcation: withoutBifurcation,
    };
    setDownloadLoading(true);
    try {
      //TODO: need to add condition when Without Bifurcation API DONE.
      const response = await fetch(
        `${API_URL}/CustomQuotaion/QuotationDownload`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
            URL: website,
          },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${QuotationDetail?.FirstName} ${
        QuotationDetail?.LastName
      } - Quotation ${QuotationDetail?.QuotationNo || ""}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download! - Please try again later");
    } finally {
      setDownloadLoading(false);
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      {downloadLoading && <LoadingPanel gridRef={gridRef} />}
      {QuotationDetail?.ID ? (
        <>
          <div className="no-visible-print-btn text-center mt-3">
            {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: 10,
                  width: 100,
                }}
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

            {isPDFDownloadAccess && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => handleDownloadInvoice(QuotationDetail?.ID)}
                style={{ marginRight: 5, width: 100 }}
              >
                Download
              </Button>
            )}
          </div>
          <div className="quotation-container">
            <div className="row">
              <div className="col-2 d-flex align-items-center">
                <img src={CompanyDetail?.CompanyLogo} alt="" width="100%" />
              </div>
              <div className="col-7" style={{ borderLeft: "1px solid black" }}>
                <h5 className="fw-600">{CompanyDetail?.CompanyName}</h5>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">GST : </span>{" "}
                    {CompanyDetail?.GSTNo}
                  </span>
                </div>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">PAN : </span>{" "}
                    {CompanyDetail?.PANNo}
                  </span>
                </div>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">Mobile : </span>{" "}
                    {CompanyDetail?.MobileNo}
                  </span>
                </div>
                <div>
                  <span className="fw-600">Email : </span>{" "}
                  {CompanyDetail?.EmailID}
                </div>
              </div>
              <div
                className="col-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {CompanyDetail?.Address} <br />
                {CompanyDetail?.CityName} - {CompanyDetail?.Pincode} <br />
                State: {CompanyDetail?.StateName} <br />
                Country: {CompanyDetail?.CountryName}
              </div>
            </div>
            <div className="section-title main-title">Quotation</div>
            <div className="details-section">
              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      <span className="info-label">Name:</span>{" "}
                      <span className="highlight">
                        {QuotationDetail?.FirstName} {QuotationDetail?.LastName}
                      </span>
                    </td>
                    <td className="w-50">
                      <span className="info-label">Date:</span>{" "}
                      {moment(QuotationDetail?.CreatedOn).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td className="w-50">
                      <span className="info-label">Mobile No.:</span>{" "}
                      {QuotationDetail?.MobileNo}
                    </td>
                    <td className="w-50">
                      <span className="info-label">Email ID:</span>{" "}
                      {QuotationDetail?.EmailID}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Start Date:</span>{" "}
                      {QuotationDetail?.StartDate
                        ? moment(QuotationDetail?.StartDate).format(
                            "DD/MM/YYYY",
                          )
                        : ""}
                    </td>
                    <td>
                      <span className="info-label">End Date:</span>{" "}
                      {QuotationDetail?.EndDate
                        ? moment(QuotationDetail?.EndDate).format("DD/MM/YYYY")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Pick Up Place:</span>{" "}
                      {QuotationDetail?.PickUpPlace}
                    </td>
                    <td>
                      <span className="info-label">Drop Place:</span>{" "}
                      {QuotationDetail?.DropPlace}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Pick Up Date:</span>{" "}
                      {QuotationDetail?.PickUpDate
                        ? moment(QuotationDetail?.PickUpDate).format(
                            "DD/MM/YYYY",
                          )
                        : ""}
                    </td>
                    <td>
                      <span className="info-label">Drop Date:</span>{" "}
                      {QuotationDetail?.DropDate
                        ? moment(QuotationDetail?.DropDate).format("DD/MM/YYYY")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Total Adult:</span>{" "}
                      {QuotationDetail?.TotalAdult}
                    </td>
                    <td>
                      <span className="info-label ">Total Room:</span>{" "}
                      {QuotationDetail?.TotalRoom}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label ">Total CNB:</span>{" "}
                      {QuotationDetail?.TotalCNB}
                    </td>
                    <td>
                      <span className="info-label">Total CWB:</span>{" "}
                      {QuotationDetail?.TotalCWB}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="section-title">Accommodation Details</div>
            <div className="section">
              {!withoutBifurcation && (
                <div className="info d-flex justify-content-between">
                  <div>
                    <span className="info-label">
                      Total Rate{" "}
                      {QuotationDetail?.AccommodationCurrencyName &&
                      QuotationDetail?.AccommodationCurrencyName !== "INR"
                        ? `(${QuotationDetail?.AccommodationCurrencyName}) `
                        : ""}
                      :
                    </span>{" "}
                    <span className="highlight">
                      {formatIndianNumber(
                        +(QuotationDetail?.TotalAccommodationRate || 0) +
                          +(QuotationDetail?.AccommodationMarkup || 0),
                      )}
                    </span>
                  </div>
                  <div>
                    <span className="info-label">Conversion Rate :</span>{" "}
                    <span className="highlight">
                      {formatIndianNumber(
                        QuotationDetail?.AccommodationConversionRate || 0,
                      )}
                    </span>
                  </div>
                </div>
              )}
              {QuotationDetail?.Accommodations?.length > 0 && (
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Place</th>
                      <th>Hotel</th>
                      <th>Check-In Date</th>
                      <th>Check-Out Date</th>
                      <th>Room Type</th>
                      <th>Meal Type</th>
                      <th>Total Room</th>
                    </tr>
                  </thead>
                  <tbody>
                    {QuotationDetail?.Accommodations.map(
                      (accommodation, index) => (
                        <tr key={index}>
                          <td>{accommodation?.Place}</td>
                          <td>{accommodation?.HotelName}</td>
                          <td>
                            {accommodation?.CheckInDate
                              ? moment(accommodation?.CheckInDate).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td>
                            {accommodation?.CheckOutDate
                              ? moment(accommodation?.CheckOutDate).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td>
                            {!isNaN(Number(accommodation?.Hotel))
                              ? accommodation?.RoomType
                              : accommodation?.RoomCategoryName}
                          </td>
                          <td>{accommodation?.MealType}</td>
                          <td>{accommodation?.TotalRoom}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {/* Transport Details Section */}
            {QuotationDetail?.Transportations?.length > 0 && (
              <>
                <div className="section-title">Transport Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div className="d-flex gap-3">
                        <div>
                          <span className="info-label">
                            Driver Allowance{" "}
                            {QuotationDetail?.TransportaionCurrencyName &&
                            QuotationDetail?.TransportaionCurrencyName !== "INR"
                              ? `(${QuotationDetail?.TransportaionCurrencyName}) `
                              : ""}
                            :
                          </span>{" "}
                          <span className="highlight">
                            {formatIndianNumber(
                              QuotationDetail?.DriverAllowance || 0,
                            )}
                          </span>
                        </div>
                        <span className="fw-bold" style={{ color: "#0073e6" }}>
                          |
                        </span>
                        <div>
                          <span className="info-label">
                            Toll Tax{" "}
                            {QuotationDetail?.TransportaionCurrencyName &&
                            QuotationDetail?.TransportaionCurrencyName !== "INR"
                              ? `(${QuotationDetail?.TransportaionCurrencyName}) `
                              : ""}
                            :
                          </span>{" "}
                          <span className="highlight">
                            {formatIndianNumber(QuotationDetail?.TotalTax || 0)}
                          </span>
                        </div>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            QuotationDetail?.TransportaionConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}

                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Vehicle Type</th>
                        <th>Place</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        {/* <th>Rate</th> */}
                        <th>Qty.</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {QuotationDetail?.Transportations.map(
                        (transport, index) => (
                          <tr key={index}>
                            <td>{transport.VehicleType}</td>
                            <td>{transport.Place}</td>
                            <td>
                              {transport.FromDate
                                ? moment(transport.FromDate).format(
                                    "DD/MM/YYYY",
                                  )
                                : ""}
                            </td>
                            <td>
                              {transport.ToDate
                                ? moment(transport.ToDate).format("DD/MM/YYYY")
                                : ""}
                            </td>
                            {/* <td>{formatIndianNumber(transport.Rate || 0)}</td> */}
                            <td>{transport.Qty || 0}</td>
                            <td style={{ maxWidth: "200px" }}>
                              {transport?.Remarks || "-"}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>

                  {!withoutBifurcation && (
                    <div className="info text-end">
                      <span className="info-label">Total:</span>{" "}
                      <span className="highlight">
                        {formatIndianNumber(
                          +(QuotationDetail?.TotalTransportation || 0) +
                            +(QuotationDetail?.TransportMarkup || 0),
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Miscellaneous Details Section */}
            {QuotationDetail?.Miscellaneous?.length > 0 && (
              <>
                <div className="section-title">Miscellaneous Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div>
                        <span className="info-label">
                          Total Rate{" "}
                          {QuotationDetail?.MiscellaneousCurrencyName &&
                          QuotationDetail?.MiscellaneousCurrencyName !== "INR"
                            ? `(${QuotationDetail?.MiscellaneousCurrencyName}) `
                            : ""}
                          :
                        </span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            +(QuotationDetail?.TotalMiscellaneous || 0) +
                              +(QuotationDetail?.MiscellaneousMarkup || 0),
                          )}
                        </span>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            QuotationDetail?.MiscellaneousConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Title</th>
                        {/* <th>Total Amount</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {QuotationDetail?.Miscellaneous.map((misc, index) => (
                        <tr key={index}>
                          <td>{misc.Title}</td>
                          {/* <td>{formatIndianNumber(misc.TotalAmount || 0)}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Sightseen Details Section */}
            {QuotationDetail?.SightSeen?.length > 0 && (
              <>
                <div className="section-title">SightSeen Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div>
                        <span className="info-label">
                          Total Rate{" "}
                          {QuotationDetail?.SightSeenCurrencyName &&
                          QuotationDetail?.SightSeenCurrencyName !== "INR"
                            ? `(${QuotationDetail?.SightSeenCurrencyName}) `
                            : ""}
                          :
                        </span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            +(QuotationDetail?.TotalSightSeen || 0) +
                              +(QuotationDetail?.SightSeenMarkup || 0),
                          )}
                        </span>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            QuotationDetail?.SightSeenConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>SightSeen Name</th>
                        {/* <th>Total Amount</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {QuotationDetail?.SightSeen.map((sightseen, index) => (
                        <tr key={index}>
                          <td>{sightseen.SightSeenName}</td>
                          {/* <td>{formatIndianNumber(misc.TotalAmount || 0)}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Total Summary Section */}

            {!withoutBifurcation ? (
              <div className="right-section">
                <div className="section-title summary-title">Total Summary</div>
                <table className="totals-table">
                  <tbody>
                    <tr>
                      <td className="label">Total Accommodation (A)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalAccommodationRate)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Transport (B)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalTransportation)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Miscellaneous (C)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalMiscellaneous)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total SightSeen (D)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalSightSeen)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (E) = (A + B + C + D)</td>
                      <td className="value">
                        {formatIndianNumber(calculateSubtotal())}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Discount (F)</td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.DiscountAmt || 0)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (G) = (E - F)</td>
                      <td className="value">
                        {formatIndianNumber(calculateAfterDiscount())}
                      </td>
                    </tr>

                    <tr>
                      <td className="label">
                        GST Amount (H){" "}
                        {QuotationDetail?.GstPer
                          ? `(${QuotationDetail?.GstPer} %)`
                          : ""}
                      </td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.GstValue || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">TCS (I)</td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.TCS || 0)}
                      </td>
                    </tr>
                    <tr
                      className="total-row grand-total"
                      style={{ backgroundColor: "#e8f4ff" }}
                    >
                      <td className="label bg-transparent">
                        Grand Total (J) = (G + H + I)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(QuotationDetail?.FinalAmt || 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="right-section">
                <div className="section-title summary-title">Total Summary</div>
                <table className="totals-table">
                  <tbody>
                    <tr className="total-row">
                      <td className="label">Total (A)</td>
                      <td className="value">
                        {formatIndianNumber(calculateSubtotal())}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Discount (B)</td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.DiscountAmt || 0)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (C) = (A - B)</td>
                      <td className="value">
                        {formatIndianNumber(calculateAfterDiscount())}
                      </td>
                    </tr>

                    <tr>
                      <td className="label">
                        GST Amount (D){" "}
                        {QuotationDetail?.GstPer
                          ? `(${QuotationDetail?.GstPer} %)`
                          : ""}
                      </td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.GstValue || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">TCS (E)</td>
                      <td className="value">
                        {formatIndianNumber(QuotationDetail?.TCS || 0)}
                      </td>
                    </tr>
                    <tr
                      className="total-row grand-total"
                      style={{ backgroundColor: "#e8f4ff" }}
                    >
                      <td className="label bg-transparent">
                        Grand Total (F) = (C + D + E)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(QuotationDetail?.FinalAmt || 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {QuotationDetail?.TourItinerary?.length > 0 && (
              <>
                <div className="itinerary-container">
                  <div className="section-title summary-title">
                    Daywise Itinerary
                  </div>
                  <table>
                    {QuotationDetail?.TourItinerary.map((itinerary, index) => (
                      <tr key={itinerary.ItinaryID}>
                        <td className="day-column">
                          <div>DAY : {index + 1}</div>
                          <div className="Image-view-Field mt-2">
                            {itinerary?.ItineraryImage ? (
                              <Link
                                to={itinerary?.ItineraryImage}
                                target="_Blanck"
                              >
                                <img
                                  className="k-form-field-wrap"
                                  src={itinerary?.ItineraryImage}
                                  alt="Itinerary Image"
                                />
                              </Link>
                            ) : (
                              <img
                                className="k-form-field-wrap"
                                src={defaultitineraryimage}
                                alt="Itinerary Image"
                              />
                            )}
                          </div>
                        </td>
                        <td className="activity-column">
                          <div className="activity-title">
                            {itinerary?.ItineraryTitle}
                          </div>
                          <div
                            className="activity-description"
                            dangerouslySetInnerHTML={{
                              __html: itinerary?.Description || "",
                            }}
                          />
                        </td>
                        <td className="location-column">
                          {itinerary?.Place}
                          <br />
                          <span className="meal-info">
                            ({itinerary?.FacilityName})
                          </span>
                        </td>
                      </tr>
                    ))}
                  </table>
                </div>
              </>
            )}

            {QuotationDetail?.TermsNCondition && (
              <>
                <div className="section-title">Terms & Conditions</div>
                <div
                  className="section"
                  dangerouslySetInnerHTML={{
                    __html: QuotationDetail?.TermsNCondition || "",
                  }}
                />
              </>
            )}

            <div className="d-flex flex-column align-items-end mt-4">
              <strong>Thank you, </strong>
              <strong>{localStorage.getItem("FullName") || ""}</strong>
            </div>
          </div>
        </>
      ) : (
        <NoDataFoundPage />
      )}
    </>
  );
};

export default PackageQuotationPrint;
